import { removeNamespace } from '@/utils/helpers'
import CategoryService from '@/services/category.service'

export const CATEGORIES_TYPES = {
  mutations: {
    SET_LOADING: 'categories/SET_CATEGORIES_LOADING',
    SET_CATEGORIES_TREE: 'categories/SET_CATEGORIES_TREE',
    SET_WORKING_CATEGORY: 'categories/SET_WORKING_CATEGORY',
    SET_WORKING_BISAC_CODE: 'categories/SET_WORKING_BISAC_CODE',
    SET_WORKING_BSM_CATEGORY: 'categories/SET_WORKING_BSM_CATEGORY'
  },
  actions: {
    fetchCategories: 'categories/fetchCategoriesPaged',
    updateCategory: 'categories/updateCategory',
    fetchCategory: 'categories/fetchCategory',
    createCategory: 'categories/createCategory',
    deleteCategory: 'categories/deleteCategory',
    fetchBisacCode: 'categories/fetchBisacCode',
    updateBisacCode: 'categories/updateBisacCode',
    fetchBsmCategory: 'categories/fetchBsmCategory',
    updateBsmCategory: 'categories/updateBsmCategory'
  }
}

const _types = removeNamespace('categories', CATEGORIES_TYPES)

const state = () => ({
  loading: false,
  categoriesTree: [],
  workingCategory: {},
  workingBisacCode: {},
  workingBsmCategory: {}
})

const getters = {}

const mutations = {
  [_types.mutations.SET_LOADING] (state, bool) {
    state.loading = bool
  },
  [_types.mutations.SET_CATEGORIES_TREE] (state, tree) {
    state.categoriesTree = tree
  },
  [_types.mutations.SET_WORKING_CATEGORY] (state, category) {
    state.workingCategory = category
  },
  [_types.mutations.SET_WORKING_BISAC_CODE] (state, bisacCode) {
    state.workingBisacCode = bisacCode
  },
  [_types.mutations.SET_WORKING_BSM_CATEGORY] (state, category) {
    state.workingBsmCategory = category
  }
}

const actions = {
  async [_types.actions.fetchCategories] ({ state, commit }) {
    commit(_types.mutations.SET_LOADING, true)
    try {
      let tree = await CategoryService.getRootCategories()
      commit(_types.mutations.SET_CATEGORIES_TREE, tree)
    } finally {
      commit(_types.mutations.SET_LOADING, false)
    }
  },
  async [_types.actions.updateCategory] ({ state, commit }) {
    commit(_types.mutations.SET_LOADING, true)
    try {
      let res = await CategoryService.updateCategory(state.workingCategory)
      let tree = await CategoryService.getRootCategories()
      commit(_types.mutations.SET_WORKING_CATEGORY, res)
      commit(_types.mutations.SET_CATEGORIES_TREE, tree)
    } finally {
      commit(_types.mutations.SET_LOADING, false)
    }
  },
  async [_types.actions.fetchCategory] ({ state, commit }, id) {
    commit(_types.mutations.SET_LOADING, true)
    try {
      let res = await CategoryService.getCategory(id)
      commit(_types.mutations.SET_WORKING_CATEGORY, res)
    } finally {
      commit(_types.mutations.SET_LOADING, false)
    }
  },
  async [_types.actions.createCategory] ({ state, commit }) {
    commit(_types.mutations.SET_LOADING, true)
    try {
      await CategoryService.createCategory(state.workingCategory)
      let tree = await CategoryService.getRootCategories()
      commit(_types.mutations.SET_CATEGORIES_TREE, tree)
    } finally {
      commit(_types.mutations.SET_LOADING, false)
    }
  },
  async [_types.actions.deleteCategory] ({ state, commit }, id) {
    commit(_types.mutations.SET_LOADING, true)
    try {
      await CategoryService.deleteCategory(id)
      let tree = await CategoryService.getRootCategories()
      commit(_types.mutations.SET_CATEGORIES_TREE, tree)
    } finally {
      commit(_types.mutations.SET_LOADING, false)
    }
  },
  async [_types.actions.fetchBisacCode] ({ state, commit }, id) {
    commit(_types.mutations.SET_LOADING, true)
    try {
      let res = await CategoryService.getBisacCode(id)
      commit(_types.mutations.SET_WORKING_BISAC_CODE, res)
    } finally {
      commit(_types.mutations.SET_LOADING, false)
    }
  },
  async [_types.actions.updateBisacCode] ({ state, commit }) {
    commit(_types.mutations.SET_LOADING, true)
    try {
      let res = await CategoryService.updateBisacCode(state.workingBisacCode)
      let tree = await CategoryService.getRootCategories()
      commit(_types.mutations.SET_WORKING_BISAC_CODE, res)
      commit(_types.mutations.SET_CATEGORIES_TREE, tree)
    } finally {
      commit(_types.mutations.SET_LOADING, false)
    }
  },
  async [_types.actions.fetchBsmCategory] ({ state, commit }, id) {
    commit(_types.mutations.SET_LOADING, true)
    try {
      let res = await CategoryService.getBsmCategory(id)
      commit(_types.mutations.SET_WORKING_BSM_CATEGORY, res)
    } finally {
      commit(_types.mutations.SET_LOADING, false)
    }
  },
  async [_types.actions.updateBsmCategory] ({ state, commit }) {
    commit(_types.mutations.SET_LOADING, true)
    try {
      let res = await CategoryService.updateBsmCategory(state.workingBsmCategory)
      commit(_types.mutations.SET_WORKING_BSM_CATEGORY, res)
    } finally {
      commit(_types.mutations.SET_LOADING, false)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
